import React, {useState, useEffect} from "react";
import {Button, Col, Form, Input, Row, Space, message} from "antd";
import {EditOutlined, CheckOutlined, CloseOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useStore} from "hooks/useStore";

const CourierSummaryMhNumber = ({mhNumber: initialMhNumber, onSave, selectedMhNumber}) => {
    const {t} = useTranslation();
    const [isEditing, setIsEditing] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const stores = useStore();

    useEffect(() => {
        if (selectedMhNumber !== undefined) {
            form.setFieldsValue({mhNumber: selectedMhNumber});
        } else {
            form.setFieldsValue({mhNumber: initialMhNumber || ""});
        }
    }, [selectedMhNumber, initialMhNumber]);

    const handleEdit = () => {
        form.setFieldsValue({mhNumber: selectedMhNumber || initialMhNumber || ""});
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
        form.resetFields();
    };

    const handleSubmit = async values => {
        try {
            setLoading(true);
            await onSave({mhNumber: values.mhNumber});
            setIsEditing(false);
        } catch (error) {
            console.error("Error updating Mh number:", error);
            message.error(
                error.response?.data?.message || t("MH Numarası güncellenirken bir hata oluştu")
            );
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = e => {
        const value = e.target.value;
        const filtered = value.replace(/[^0-9]/g, "");
        form.setFieldsValue({mhNumber: filtered});
    };

    return (
        <Form
            form={form}
            onFinish={handleSubmit}
            initialValues={{mhNumber: selectedMhNumber || initialMhNumber || ""}}
        >
            <Row gutter={[8, 8]} align="middle">
                <Col flex="auto">
                    {isEditing ? (
                        <Form.Item
                            name="mhNumber"
                            rules={[
                                {required: true, message: t("Zorunlu Alan")},
                                /*   {
                                    pattern: /^\d+$/,
                                    message: t("Sadece rakam girebilirsiniz")
                                }, */
                                {min: 3, message: t("En az 3 karakter olmalı")}
                            ]}
                            style={{marginBottom: 0}}
                        >
                            <Input
                                placeholder={t("MH Numarasını Giriniz")}
                                onChange={handleInputChange}
                            />
                        </Form.Item>
                    ) : (
                        <div style={{padding: "5px 0"}}>
                            {selectedMhNumber || initialMhNumber || t("-")}
                        </div>
                    )}
                </Col>
                <Col>
                    {stores.meStore.checkRole("updateCourierMhNumber") &&
                        (isEditing ? (
                            <Space>
                                <Button
                                    type="text"
                                    icon={<CheckOutlined />}
                                    htmlType="submit"
                                    loading={loading}
                                />
                                <Button
                                    type="text"
                                    icon={<CloseOutlined />}
                                    onClick={handleCancel}
                                    disabled={loading}
                                />
                            </Space>
                        ) : (
                            <Button type="text" icon={<EditOutlined />} onClick={handleEdit} />
                        ))}
                </Col>
            </Row>
        </Form>
    );
};

export default CourierSummaryMhNumber;
